import axios from 'axios';

export const languageService = {
    getLangiuagePairs,
	getLanguagePair
};

function getLangiuagePairs() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/lang/", {params: {}});
}

function getLanguagePair(id) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/lang/"+id, {params: {}});
}